(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-arrangement-ibq', {
            parent: 'entity',
            url: '/musical-arrangement-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangementsibq.html',
                    controller: 'MusicalArrangementIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-arrangement-ibq-detail', {
            parent: 'musical-arrangement-ibq',
            url: '/musical-arrangement-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-detail.html',
                    controller: 'MusicalArrangementIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalArrangement', function($stateParams, MusicalArrangement) {
                    return MusicalArrangement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-arrangement-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-arrangement-ibq-detail.edit', {
            parent: 'musical-arrangement-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-ibq.new', {
            parent: 'musical-arrangement-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                arrangementFile: null,
                                arrangementFileContentType: null,
                                arrangementFilePath: null,
                                pages: null,
                                comments: null,
                                instrumentation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('musical-arrangement-ibq');
                });
            }]
        })
        .state('musical-arrangement-ibq.edit', {
            parent: 'musical-arrangement-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-ibq.delete', {
            parent: 'musical-arrangement-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-delete-dialog.html',
                    controller: 'MusicalArrangementIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
